module.exports = __webpack_public_path__ + "img/Rectangle33.b33bde12.png";